/**
 * Pack the chosen fare card into the localStorage shape consumed by
 * `BookingPage.jsx`. The fare card user clicked may differ from the
 * default (cheapest) fare bundled into the flight transformer, so we
 * MUST override every field that BookingPage reads — especially
 * `fares` (per-pax-type TF object) and `fareBreakdown` (per-pax-type
 * BF/TAF/MARKUP) — otherwise the review page's `computeFlightTotal`
 * sums against the cheapest fare's `fares.adult`.
 *
 * Used by SearchResults.jsx (one-way) and InternationalRoundTripResults.jsx
 * (combo). Multi-city + domestic round-trip use their own selection
 * shapes but follow the same override contract.
 */
export function buildSelectedFlightPayload(flight, fareToBook) {
  if (!flight) return null;
  const chosen = fareToBook || flight;
  return {
    ...flight,
    price: chosen.price,
    priceId: chosen.priceId,
    baseFare: chosen.baseFare || flight.baseFare,
    taxes: chosen.taxes || flight.taxes,
    baggage: chosen.baggage || flight.baggage,
    cabinBaggage: chosen.cabinBaggage || flight.cabinBaggage,
    fareType: chosen.fareType || flight.fareType,
    tripBaggageBySegmentId:
      chosen.tripBaggageBySegmentId ?? flight.tripBaggageBySegmentId,
    fares: chosen.fares || flight.fares,
    fareBreakdown: chosen.fareBreakdown || flight.fareBreakdown,
    originalPrice: chosen.price,
    seatsLeft: chosen.seatsLeft ?? flight.seatsLeft,
    mealIncluded: chosen.mealIncluded ?? flight.mealIncluded,
    refundableType: chosen.refundableType ?? flight.refundableType,
  };
}
